import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePageStatus } from 'redux/actions/ui.action';
import backgroundMySession from 'static/svg/bg-topic-detail.svg';
import Section from 'views/components/core/Section';
import './custom-home.scss';
import CardMvpSession from '../../components/core/CardSession';

import {
  getCategorySessions,
  getListBuddyRole,
  getListStatusSession,
  getMySessions,
  fetchNeedEvaluateSessions,
} from 'redux/actions/mvp/session.action';
import { PageHero, PageLoader } from '@kambria/kambria-lego';
import RatingFloatNotification from '../../components/core/RatingFloatNotification';
// import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// import { DotLottie } from '@lottiefiles/dotlottie-web';
// import animate from 'static/animation.lottie'

import config from 'config';
// import Pagination from "../../components/core/Pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ConfigProvider, DatePicker, Select } from 'antd';
import moment from 'moment/moment';
import debounce from 'lodash/debounce';
import _ from 'lodash';
import { I18n, getAntdLocale } from '../../../helpers/i18n';

class MySession extends React.Component {
  constructor() {
    super();
    this.state = {
      visibleMembershipModal: false,
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 40,
      listSessions: [],
      listStatus: [],
      filterKeySearch: '',
      categories: [],
      roles: [],
      filterCategories: [],
      filterStatus: [],
      filterEvaluating: [],
      filterRole: null,
      filterCreateDate: null,
      filterLanguage: null,
      openFilterCreateDate: false,
      startDate: null,
      endDate: null,
      evaluating: [],
      createDate: [],
      languages: [],
      pendingRatingSession: null,
    };
  }

  style = {
    backgroundImage: `url(${backgroundMySession})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    minHeight: '1px',
  };

  async componentDidMount() {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    this.props.updatePageStatus('loading');
    setTimeout(() => {
      this.setState({
        evaluating: [
          { value: 1, key: 1, label: I18n.t('from_one_star') },
          { value: 2, key: 2, label: I18n.t('from_two_star') },
          { value: 3, key: 3, label: I18n.t('from_three_star') },
          { value: 4, key: 4, label: I18n.t('from_four_star') },
          { value: 5, key: 5, label: I18n.t('five_star') },
        ],
        createDate: [
          { value: 'today', label: I18n.t('today') },
          { value: 'yesterday', label: I18n.t('yesterday') },
          { value: 'thisWeek', label: I18n.t('this_week') },
          { value: 'sevenDaysAgo', label: I18n.t('7_days_ago') },
          { value: 'other', label: I18n.t('range_calendar') },
        ],
      });
    }, 0);
    const { getMySessions, getCategorySessions, getListStatusSession, getListBuddyRole } = this.props;
    const params = this.mapUrlToFilter();
    const newState = {};
    if (this.props.listLanguage?.length) {
      newState.languages = this.props.listLanguage.map((item) => ({
        key: item.value,
        value: item.value,
        label: item.label,
      }));
    }
    let categories = [],
      arrStatus = [],
      roles = [],
      sessions = [];
    if (Object.keys(params).length) {
      [categories, arrStatus, roles] = await Promise.all([
        getCategorySessions(),
        getListStatusSession(),
        getListBuddyRole(),
      ]);
    } else {
      [categories, sessions, arrStatus, roles] = await Promise.all([
        getCategorySessions(),
        getMySessions(),
        getListStatusSession(),
        getListBuddyRole(),
      ]);
    }
    arrStatus = arrStatus?.data || [];
    arrStatus = arrStatus.map((item) => ({
      key: item.value,
      value: item.value,
      label: item.label,
    }));
    categories = categories?.map((item) => ({
      key: item._id,
      value: item._id,
      label: item.name,
    }));

    const { categoryId, evaluating, keySearch, startDate, endDate, status, role, language } = params;

    if (language) {
      newState.filterLanguage = language;
    }

    if (categoryId) {
      const cateIds = categoryId.split(',');
      const cateInfo = categories.filter((obj) => cateIds.includes(obj.key));
      this.handleSelectMulti(cateInfo, 'filterCategories', I18n.t('session_category_label_required'));
    }

    if (status) {
      const fStatus = status.split(',');
      const fStatusInfo = arrStatus.filter((obj) => fStatus.includes(obj.key));
      this.handleSelectMulti(fStatusInfo, 'filterStatus', I18n.t('dashboard_filter_status'));
    }

    if (evaluating) {
      const fEvaluating = evaluating.split(',');
      const data = this.state.evaluating.filter((obj) => fEvaluating.includes(String(obj.key)));
      this.handleSelectMulti(data, 'filterEvaluating', I18n.t('dashboard_filter_rating'));
    }

    if (role) {
      const data = roles.filter((obj) => obj.value === role);
      this.handleSelect(data, 'filterRole', I18n.t('dashboard_filter_provider'));
    }

    if (keySearch) {
      newState.filterKeySearch = keySearch;
    }

    if (startDate || endDate) {
      this.handleSelectCreateDate({ value: 'other', label: I18n.t('range_calendar'), key: 'other' });
      if (startDate) this.handleStartTime(moment(Number(startDate)));
      if (endDate) this.handleEndTime(moment(Number(endDate)));
    }

    if (!categoryId && !evaluating && !role && !status && !keySearch && !language) {
      await this.handleFilter();
    }

    newState.categories = categories;
    newState.roles = roles;
    newState.listStatus = arrStatus;
    if (sessions?.success) {
      newState.listSessions = sessions.data.data.list;
    }
    this.setState(newState);
    this.props.updatePageStatus('loaded');
    this.fetchPendingRatingSession();
    //
    // let cred = await Auth.currentUserCredentials();
    //
    // if (!cred || !cred.authenticated) this.openMembershipModal();
    //
    //   const dotLottie = new DotLottie({
    //     autoplay: true,
    //     loop: true,
    //     canvas: document.querySelector('#dotlottie-canvas'),
    //     src: animate
    //   });
  }

  fetchPendingRatingSession = async () => {
    const { user } = this.props;
    if (!user?._id && !user?.id) return;
    try {
      const data = await fetchNeedEvaluateSessions()();
      if (data && data.length > 0) {
        this.setState({ pendingRatingSession: data[0] });
      }
    } catch (err) {
      console.log('fetchPendingRatingSession error', err);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.listLanguage !== prevProps.listLanguage) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const language = searchParams.get('language');
      const languages = this.props.listLanguage.map((item) => ({
        key: item.value,
        value: item.value,
        label: item.label,
      }));
      this.setState({ languages: languages });
      if (language) {
        const data = languages.find((obj) => obj.key === language);
        this.handleSelect(data, 'filterLanguage', I18n.t('language'));
      }
    }

    const {
      filterCategories,
      filterEvaluating,
      filterKeySearch,
      filterCreateDate,
      filterStatus,
      filterRole,
      filterLanguage,
    } = this.state;
    const currentFilters = {
      filterCategories,
      filterEvaluating,
      filterKeySearch,
      filterCreateDate,
      filterRole,
      filterStatus,
      filterLanguage,
    };
    const prevFilters = {
      filterCategories: prevState.filterCategories,
      filterEvaluating: prevState.filterEvaluating,
      filterKeySearch: prevState.filterKeySearch,
      filterCreateDate: prevState.filterCreateDate,
      filterRole: prevState.filterRole,
      filterStatus: prevState.filterStatus,
      filterLanguage: prevState.filterLanguage,
    };
    const handleToOther = prevState.filterCreateDate !== filterCreateDate && this.isOther();
    if (handleToOther) {
      return;
    }
    if (!_.isEqual(currentFilters, prevFilters)) {
      await this.handleChangeDebounced();
    }
  }

  mapFilterToUrl = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });

    this.props.history.push({ search: searchParams.toString() });
  };

  mapUrlToFilter = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const categoryId = searchParams.get('categoryId');
    const evaluating = searchParams.get('evaluating');
    const keySearch = searchParams.get('keySearch');
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    const status = searchParams.get('status');
    const role = searchParams.get('role');
    const language = searchParams.get('language');
    return { categoryId, evaluating, keySearch, startDate, endDate, status, role, language };
  };

  handleSearchChange = async (e) => {
    this.setState({ filterKeySearch: e.target.value });
  };
  handleFilterDate = async (event) => {
    const { startDate, endDate } = this.state;
    if (this.isOther() && !startDate && !endDate) {
      await this.handleClearSelectDate(null);
    }
    await this.handleFilter(null);
    this.setState({ openFilterCreateDate: false });
  };
  handleStartTime = (value) => {
    const endDate = this.state.endDate?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({ startDate: null });
      return;
    }
    this.setState({ startDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        if (this.isOther()) {
          if (startDate && endDate) {
            title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
          } else if (startDate) {
            title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
          } else if (endDate) {
            title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
          }
        } else {
          title = `${filterCreateDate.label}`;
        }
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      }
    });
  };
  handleClearSelectDate = (event) => {
    if (event) {
      event.target.blur();
    }
    this.setState({
      filterCreateDate: null,
      startDate: null,
      endDate: null,
    });
  };
  handleEndTime = (value) => {
    const startDate = this.state.startDate?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({ endDate: null });
      return;
    }
    this.setState({ endDate: value }, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        if (this.isOther()) {
          if (startDate && endDate) {
            title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
          } else if (startDate) {
            title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
          } else if (endDate) {
            title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
          }
        } else {
          title = `${title}: ${filterCreateDate.label}`;
        }
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      }
    });
  };
  handleSelectCreateDate = (value) => {
    if (!value) {
      this.handleClearSelectDate(null);
      return;
    }
    const state = { filterCreateDate: value };
    if (value !== 'other') {
      state.startDate = null;
      state.endDate = null;
    }

    this.setState(state, () => {
      const { filterCreateDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        title = `${title}: ${filterCreateDate.label}`;
        spans[0].innerHTML = title;
      }
    });
  };
  isOther = () => this.state.filterCreateDate?.value === 'other';
  handleDropdownVisibleChange = (open) => {
    setTimeout(() => {
      if (this.isOther() && !open) {
        return;
      }
      this.setState({ openFilterCreateDate: open });
    }, 0);
  };
  handleSelect = (value, select, label) => {
    if (!value) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && selectedItems && selectedItems.value) {
        title = `${label}: ${selectedItems.label}`;
        spans[0].innerHTML = title;
      }
    });
  };
  renderSelect = ({ label, select, options }) => {
    const selectedItems = this.state[select];
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        value={selectedItems}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={label}
        onChange={(value) => this.handleSelect(value, select, label)}
        dropdownRender={(menu) => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                <div className="d-flex">
                  <button onClick={(event) => this.handleClearSelect(event, select)} className="clear-all">
                    {I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilter} className="apply">
                    {I18n.t('apply')}
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };
  renderSelectDate = (options) => {
    const { filterCreateDate, openFilterCreateDate, startDate, endDate } = this.state;

    return (
      <Select
        className="createDate"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDate}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDate}
        placeholder={I18n.t('dashboard_filter_date')}
        onChange={this.handleSelectCreateDate}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={(menu) => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOther() && (
                  <ConfigProvider locale={getAntdLocale()}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={getAntdLocale()}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTime}
                        value={startDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div
                        className="d-flex align-items-center mr-2 ml-2"
                        style={{ color: '#9CA3AF', fontSize: '16px' }}
                      >
                        -
                      </div>
                      <DatePicker
                        locale={getAntdLocale()}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTime}
                        value={endDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button onClick={this.handleClearSelectDate} className="clear-all">
                    {I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDate} className="apply">
                    {I18n.t('apply')}
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };
  handleChangeDebounced = debounce(() => this.handleFilter(null), 500);
  getStartEndDate = (date) => {
    if (!date) {
      return { startDate: null, endDate: null };
    }
    let startDate, endDate;
    switch (date) {
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;

      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;

      case 'thisWeek':
        startDate = moment().startOf('week').startOf('day');
        endDate = moment().endOf('week').endOf('day');
        break;

      case 'sevenDaysAgo':
        startDate = moment().subtract(7, 'days').startOf('day');
        endDate = moment().subtract(7, 'days').endOf('day');
        break;

      default:
        if (this.state.startDate) {
          startDate = moment(this.state.startDate).startOf('day');
        }
        if (this.state.endDate) {
          endDate = moment(this.state.endDate).endOf('day');
        }
        break;
    }

    return {
      startDate: startDate?.valueOf() || null,
      endDate: endDate?.valueOf() || null,
    };
  };
  handleFilter = async (event) => {
    if (event) {
      event.target.blur();
    }

    const {
      filterEvaluating,
      filterCategories,
      filterKeySearch,
      filterCreateDate,
      filterStatus,
      filterRole,
      filterLanguage,
    } = this.state;
    const { getMySessions } = this.props;

    let categoryId = null;
    if (filterCategories && filterCategories.length) {
      categoryId = filterCategories.map((c) => c.value).join(',');
    }
    const role = filterRole?.value || null;
    const language = filterLanguage?.value || null;
    let status = null;
    if (filterStatus && filterStatus.length) {
      status = filterStatus.map((c) => c.value).join(',');
    }
    let evaluating = null;
    if (filterEvaluating && filterEvaluating.length) {
      evaluating = filterEvaluating.map((c) => c.value).join(',');
    }
    const keySearch = (filterKeySearch || '').trim();
    let startDate, endDate;
    if (filterCreateDate && filterCreateDate.value) {
      const filterDate = this.getStartEndDate(filterCreateDate.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }
    this.mapFilterToUrl({ categoryId, evaluating, keySearch, startDate, endDate, status, role, language });
    const sessions = await getMySessions({
      categoryId,
      evaluating,
      keySearch,
      startDate,
      endDate,
      status,
      role,
      language,
    });
    if (sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list;
      this.setState({
        listSessions,
      });
    }
  };

  handleClearSelect = (event, select) => {
    if (event) {
      event.target.blur();
    }
    this.setState({ [select]: null }, () => {
      let element = document.querySelectorAll(`.${select}  .ant-select-selector label`);
      if (element.length) {
        element[0].remove();
      }
      element = null;
    });
  };
  renderSelectMulti = ({ label, select, options }) => {
    const selectedItems = this.state[select];
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        mode="multiple"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={selectedItems}
        placeholder={label}
        onChange={(value) => this.handleSelectMulti(value, select, label)}
        dropdownRender={(menu) => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                <div className="d-flex">
                  <button onClick={(event) => this.handleClearSelect(event, select)} className="clear-all">
                    {I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilter} className="apply">
                    {I18n.t('apply')}
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  handleSelectMulti = (value, select, label) => {
    if (!value.length) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      let spans = element[0].querySelectorAll('label');
      if (spans.length) {
        spans.forEach((span) => span.remove());
      }
      if (selectedItems && selectedItems.length) {
        if (selectedItems.length > 1) {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else {
          title = `${label}: ${selectedItems[0].label}`;
        }
        if (element.length) {
          element[0].innerHTML += `<label>${title}</label>`;
        }
      }
      element = null;
      spans = null;
    });
  };

  render() {
    const { languages, filterKeySearch, listSessions, categories, evaluating, createDate, listStatus, roles } =
      this.state;
    const { user } = this.props;
    return (
      <div id="site_wrapper">
        <div className="site-upper">
          {this.props.header}
          <div style={this.style} className="page-hero-cus">
            <PageHero description={I18n.t('my_session')} />
          </div>
        </div>
        <main className="main">
          <div className="container">
            {/*<canvas id="dotlottie-canvas"/>*/}
            {/*<DotLottieReact*/}
            {/*  // src={animate}*/}
            {/*  loop*/}
            {/*  autoplay*/}
            {/*  width="400px"*/}
            {/*  height="400px"*/}
            {/*/>*/}
            <PageLoader loading={!listSessions} />
            {listSessions && (
              <Section title="" url="/" className="card-section">
                <div className="mtp-filter-zone">
                  <div className="search">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      icon={faSearch}
                      style={{ fontSize: '18px', color: '#9CA3AF' }}
                    />
                    <input
                      value={filterKeySearch}
                      onChange={this.handleSearchChange}
                      placeholder={I18n.t('my_dashboard_topic_search_hint_text')}
                    />
                  </div>
                  <div className="select">
                    {this.renderSelectMulti({
                      label: I18n.t('dashboard_filter_status'),
                      select: 'filterStatus',
                      options: listStatus,
                    })}
                    {this.renderSelectDate(createDate)}
                    {user &&
                      user.type === 'seniorBuddy' &&
                      this.renderSelect({
                        label: I18n.t('dashboard_filter_provider'),
                        select: 'filterRole',
                        options: roles,
                      })}
                    {this.renderSelectMulti({
                      label: I18n.t('session_category_label_required'),
                      select: 'filterCategories',
                      options: categories,
                    })}
                    {this.renderSelectMulti({
                      label: I18n.t('rating'),
                      select: 'filterEvaluating',
                      options: evaluating,
                    })}
                  </div>
                  <div className="select">
                    {this.renderSelect({
                      label: I18n.t('language'),
                      select: 'filterLanguage',
                      options: languages,
                    })}
                  </div>
                </div>
                <div className="row">
                  {listSessions.map((item, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <CardMvpSession
                          key={index}
                          data={item}
                          status={item.status}
                          url={config.sites.bounty}
                          user={this.props.user}
                        />
                      </div>
                    );
                  })}
                </div>
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}
        {this.state.pendingRatingSession && (
          <RatingFloatNotification
            session={this.state.pendingRatingSession}
            onDismiss={() => this.setState({ pendingRatingSession: null })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  listLanguage: state.mvp.listLanguage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMySessions,
      updatePageStatus,
      getCategorySessions,
      getListStatusSession,
      getListBuddyRole,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MySession);
